export function getReferredByCode() {
  if (typeof window === 'undefined') return null

  const code = localStorage.getItem('referralCode')
  const timestamp = localStorage.getItem('referralTimestamp')

  // Validate timestamp - expire after 30 days
  if (
    timestamp &&
    Date.now() - parseInt(timestamp) > 30 * 24 * 60 * 60 * 1000
  ) {
    localStorage.removeItem('referralCode')
    localStorage.removeItem('referralTimestamp')
    return null
  }

  return code
}

export function storeReferralCode(code: string) {
  if (typeof window !== 'undefined') {
    localStorage.setItem('referralCode', code)
    // Store timestamp to potentially expire old referral codes
    localStorage.setItem('referralTimestamp', Date.now().toString())
  }
}
